<template>
	<div>
		<div class="page-title"><span>How to play</span></div>
		<div class="md-layout" style="margin-top: 15px;">
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			// this.getGame();
		},
		methods: {
			// getGame() {
			// 	this.$http.post(this.config.api + "/public/game/search", {
			// 		text: "",
			// 		provider: "",
			// 		game_type: 2,
			// 		offset: 0
			// 	}).then(res => {
			// 		if (res.body.status == 'success') {
			// 			this.loaded = true;
			// 			this.gameList= res.body.data
			// 		}
			// 	})
			// },
		},
		computed: {
		},
		data() {
			return {
				loaded: false
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Page/HowToPlay.vue